<template>
  <div>
    <div v-if="!willSetCustomDates">

      <button :class="isSelected('day')" v-on:click="handleSelectDate('day')">Day</button>
      <button :class="isSelected('week')" v-on:click="handleSelectDate('week')">Week</button>
      <button :class="isSelected('month')" v-on:click="handleSelectDate('month')">Month</button>
      <button :class="isSelected('year')" v-on:click="handleSelectDate('year')">Year</button>

      <br>
      <button :class="isSelected('current')" v-on:click="handleSelectPeriod('current')">Current</button>
      <button :class="isSelected('previous')" v-on:click="handleSelectPeriod('previous')">Previous</button>
      <button :class="isSelected('next_previous')" v-on:click="handleSelectPeriod('next_previous')">Next Previous</button>

      &nbsp;&nbsp;&nbsp;
      Period Window:
      <button :class="isSelected('toNow')" v-on:click="handleSelectPeriodEnd('toNow')">Up To Now</button>
      <button :class="isSelected('toEnd')" v-on:click="handleSelectPeriodEnd('toEnd')">To End Of Period</button>
      <button :class="isSelected('rollingWindow')" v-on:click="handleSelectPeriodEnd('rollingWindow')">Rolling Window</button>
    </div>
    
    <br>
    <button :class="willSetCustomDates ? 'selected' : ''" v-on:click="toggleCustom()">Custom</button>
    
    <div v-if="willSetCustomDates">
      <br>
      <p>Date Format Style: YYYY-MM-DD HH:mm:ss</p>
      From:
      
      <input v-model="custom.from">
      To:
      
      <input v-model="custom.to">
      <button :class="isSelected('custom')" v-on:click="handleSelectPeriodEnd('custom')">Get Data</button>
    </div>  
  </div>  
</template>

<script>
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  name: 'DatePeriodSelector',
  mixins : [localstorageMixin],
  props : ['value', 'lsComponentName'],
  data () { return { 
      ls: {
        selectedDateType: 'day',
        selectedPeriod: 'current',
        selectedPeriodEnd: 'toNow',
      },
      timestamps: {
        from: undefined,
        to: undefined,
      },
      custom: {
        from: new Date(),
        to: new Date(),
      },
      offset: 0,
      willSetCustomDates: false,
    } 
  },
  watch: {
    'timestamps.from': 'emitValue',
    'timestamps.to': 'emitValue',
  },
  created: function(){
    this.timestamps = this.value
    this.handleSelectPeriod();
  },
  methods: {
    emitValue: function(val){
      if (val === undefined){
        return;
      }
      this.$emit('input', this.timestamps)
    },
    isSelected: function(s){
      return this.ls.selectedDateType === s || this.ls.selectedPeriod === s || this.ls.selectedPeriodEnd === s ? 'selected' : ''
    },
    handleSelectDate: async function(s=this.ls.selectedDateType){
      const ts = (await this.$axios.get('/ts')).data.ts
      this.ls.selectedDateType = s
      this.value.from = moment(ts).startOf(s).add(this.offset, s).toDate()
      this.value.from = s === 'year' ? moment(ts).startOf('year').subtract(moment(ts).startOf('month').month() > 7 ? 0 : 1, 'year').add(7, 'months').add(this.offset, s).toDate() : this.value.from
      const handleSelection = {
        toNow: () => this.value.to = moment(ts).add(this.offset, s).toDate(),
        toEnd: () => {
          this.value.to = moment(ts).endOf(s).add(this.offset, s).toDate()
          this.value.to = s === 'year' ? moment(ts).endOf('year').subtract(moment(ts).startOf('month').month() > 7 ? 2 : 1, 'year').add(7, 'months').add(this.offset, s).toDate() : this.value.to
        },
        rollingWindow: () => {
          this.value.from = moment(ts).subtract(1, s).add(this.offset, s).toDate()
          this.value.to = moment(ts).add(this.offset, s).toDate();
        },
        custom: () => {
          this.value.from = moment(this.custom.from, 'YYYY-MM-DD HH:mm:ss').toDate();
          this.value.to = moment(this.custom.to, 'YYYY-MM-DD HH:mm:ss').toDate();
        },
      }
      handleSelection[this.ls.selectedPeriodEnd]();
    },
    handleSelectPeriod: function(selection=this.ls.selectedPeriod){
      const periods = {'current':0, 'previous': -1, 'next_previous': -2}
      this.offset = periods[selection] !==undefined ? periods[selection] : 0;
      this.ls.selectedPeriod = selection
      this.handleSelectDate();
    },
    handleSelectPeriodEnd : function(selection=this.ls.selectedPeriod){
      this.ls.selectedPeriodEnd = selection;
      this.handleSelectDate();
    },
    toggleCustom : function(){
      this.willSetCustomDates = !this.willSetCustomDates
      if (this.willSetCustomDates){
        this.custom.from = moment(this.value.from).format('YYYY-MM-DD HH:mm:ss')
        this.custom.to = moment(this.value.to).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.ls.selectedDateType = 'day'
        this.ls.selectedPeriod = 'current'
        this.ls.selectedPeriodEnd = 'toNow'
        this.value.from = new Date()
        this.value.to = new Date()
        this.handleSelectDate()

      }
    },
  }
}
</script>

<style scoped>

</style>
